// extracted by mini-css-extract-plugin
export var currencyInput = "_oo-1";
export var currencySymbol = "_oo-0";